import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type TokenExpirationProps = BaseNotificationItemProps & {
  name: string
  description: string
  day: number
  type: 'token-expiration'
}

export function TokenExpiration({ name, description, day, ...props }: TokenExpirationProps) {
  return (
    <NotificationItem
      {...props}
      title={`Your API Token will expire in ${day} days (${name})`}
      descriptionAddon={<p className='line-clamp-1 text-left text-sm text-gray-500'>{description}</p>}
    />
  )
}
